<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="data-card-first fit row">
            <div class="col-4 text-center self-center">
              <div class="bg-transparent no-padding" style="max-height: 86px;">
                <img id="avatar" :src="url" style="width: 50%;" />
              </div>
            </div>
            <div class="col-8 row">
              <div
                v-for="(obj, index) in computedDataFirst"
                :key="index"
                :class="
                  !obj.columnsPerLine
                    ? 'col-12'
                    : 'col-md-' + 12 / obj.columnsPerLine
                "
              >
                <label>{{ obj.label }}:</label>
                {{ obj.value }}
              </div>
            </div>
          </q-card-section>
          <q-card-section class="data-card-second fit row">
            <div class="row">
              <div
                v-for="(obj, index) in computedDataSecond"
                :key="index"
                :class="
                  !obj.columnsPerLine
                    ? 'col-12'
                    : 'col-md-' + 12 / obj.columnsPerLine
                "
              >
                <label>{{ obj.label }}:</label>
                {{ obj.value }}
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import { JtCrud } from 'jtech-webcomps'
import * as logo from '../../../assets/imageNotFound.png'

const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'companyDetailPage',
  components: {},
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class CompanyDetailPage extends Vue {
  image = null;

  async mounted () {
    if (this.elements[0].dadosForm.photo) {
      const file = await repository.downloadFile(
        this.elements[0].dadosForm.photo,
        null,
        'PERSON_IMAGE'
      )
      if (file) {
        this.previewImage(file)
      }
    }
  }

  previewImage (file) {
    const reader = new FileReader()
    reader.onload = () => {
      this.image = reader.result
    }
    reader.readAsDataURL(file)
  }

  get url () {
    return this.image || logo
  }

  get computedDataFirst () {
    this.computedData()
    return this.elements[0].inputs.filter(
      ci =>
        ci.name == 'fantasyName' ||
        ci.name == 'name' ||
        ci.name == 'document' ||
        ci.name == 'integrationCode'
    )
  }

  get computedDataSecond () {
    this.formartPhone()
    this.computedData()
    return this.elements[0].inputs.filter(
      ci =>
        ci.name !== 'fantasyName' &&
        ci.name !== 'name' &&
        ci.name !== 'document' &&
        ci.type !== 'FILE' &&
        ci.name !== 'integrationCode'
    )
  }

  formartPhone () {
    const { phone, alternativePhone } = this.elements[0].dadosForm
    this.elements[0].dadosForm.phones = [phone, alternativePhone]
      .filter(obj => obj)
      .join(' / ')
  }

  computedData () {
    this.elements[0].inputs.forEach(input => {
      input.value = this.__formatFilterChipValue(
        input,
        this.elements[0].dadosForm
      )
    })
  }

  __formatFilterChipValue (filtered, model) {
    switch (filtered.type.toLowerCase()) {
      case 'select':
      case 'select_ajax':
        return this.__getTypeSelectValueLabel(
          filtered.model,
          model[filtered.model]
        )
      case 'date':
        return this.__getFormatedData(filtered, model)
      case 'date_range':
        return this.__getFormatedDataRange(filtered, model)
      default:
        return model[filtered.model]
    }
  }

  __getTypeSelectValueLabel (key, value) {
    const el = this.elements[0].relacionamentos[key].find(
      rel => rel.value === value
    )
    return el ? el.label : value
  }

  __getFormatedData (filtered, model) {
    // eslint-disable-next-line no-undef
    return date.formatDate(model[filtered.model], filtered.format)
  }

  __getFormatedDataRange (filtered, model) {
    const format = filtered.format.toUpperCase()
    return `${model[filtered.model].inicial} - ${model[filtered.model].final} `
  }
}
export default CompanyDetailPage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.data-card-header {
  font-size: 1.3em;
  padding: 10px 17px 0px;
}

.data-card-first.q-card__section,
.data-card-second.q-card__section, {
  height: calc(100% - 65px);
  overflow: hidden;
}

.data-card-first.q-card__section > div > div,
.data-card-second.q-card__section > div > div,  {
  padding: 5px 12px;
}

.data-card-first.q-card__section > div > div > label,
.data-card-second.q-card__section > div > div > label, {
  font-weight: bold;
}

.data-card-first.q-card__section > div > div:nth-child(odd) {
  background-color: $ice;
}

.data-card-first.q-card__section > div > div:nth-child(4) {
  background-color: $ice;
}
.data-card-second.q-card__section > div >
  div:nth-child(1), div:nth-child(2),
  div:nth-child(5), div:nth-child(6),
  div:nth-child(8), div:nth-child(9),
  div:nth-child(11), div:nth-child(13), {
  background-color: $ice;
}
</style>
